"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const react_1 = require("react");
require("./anchorButton.scss");
const types_1 = require("./types");
function AnchorButton(_a, ref) {
    var { className, variant = types_1.defaultVariant, size = types_1.defaultSize, iconPosition = types_1.defaultIconPosition, fluid = false, children, icon } = _a, props = __rest(_a, ["className", "variant", "size", "iconPosition", "fluid", "children", "icon"]);
    return ((0, jsx_runtime_1.jsxs)("a", Object.assign({ className: (0, classnames_1.default)('link-button', `button-variant--${variant}`, `button-size--${size.toLowerCase()}`, {
            'link-button--fluid': fluid,
        }, className), ref: ref }, props, { children: [icon && (0, jsx_runtime_1.jsx)("span", { className: (0, classnames_1.default)('button-icon', `button-icon--${iconPosition}`), children: icon }), (0, jsx_runtime_1.jsx)("span", { className: "button-content", children: children })] })));
}
exports.default = (0, react_1.forwardRef)(AnchorButton);
